
		if ('serviceWorker' in navigator && import.meta.env.PROD) {
			window.addEventListener('load', () => {
				navigator.serviceWorker
					.register('/service-worker.js', { updateViaCache: 'none' })
					.catch((error) => {
						console.error('SW registration error', error);
					});
			});
		}
	